import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { Typography, Page } from "@packages/ui";
import UploadRentalPhotoContainer from "../../components/UploadRentalPhoto";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 15,
    paddingBottom: theme.spacing(3),
  },
}));

const UploadRentalPhoto = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Take New Photos - My Journey Portal">
      <Grid container>
        <Grid item md={12}>
          <Typography variant="h1" style={{ marginBottom: 30 }}>
            Take New Photos
          </Typography>
        </Grid>
        <UploadRentalPhotoContainer />
      </Grid>
    </Page>
  );
};

export default UploadRentalPhoto;
